import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { ERROR_MESSAGES } from '../../../configs/messages';
import showMessage from '../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { useAuth } from '../../providers/AuthProvider';
import { Grid } from '@mui/material';
import { ROUTES_LIST } from '../../../helpers/routesList';
import { NavLink } from 'react-router-dom';

function Copyright(props) {
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            {...props}
        >
            {'Зохиогчийн эрх © '}
            <Link color="inherit" href="https://www.mongolcontent.mn/">
                Mongol Content
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const theme = createTheme({
    palette:{
        secondary:{
            main: '#fe4f70'
        }
    }
});

export default function Login() {
    const [errors, setErrors] = useState({});
    const [data, setData] = useState({
        email: '',
        password: '',
    });

    const auth = useAuth();

    const { enqueueSnackbar } = useSnackbar();

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setData({
            ...data,
            [name]: value,
        });
    };

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;

        if ('email' in data) {
            tempErrors.email = data.email ? '' : requiredMessage;
        }

        if ('password' in data) {
            tempErrors.password = data.password ? '' : requiredMessage;
        }

        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        e.preventDefault();
        const tempErrors = validate();

        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        auth.logIn(data.email, data.password);
    };

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
                {/* <CssBaseline /> */}
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Нэвтрэх
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        noValidate
                        sx={{ mt: 1 }}
                    >
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            type="email"
                            id="email"
                            label="И-мэйл хаяг"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            onChange={handleInputChange}
                            error={Boolean(errors.email)}
                            helperText={errors.email}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Нууц үг"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onChange={handleInputChange}
                            error={Boolean(errors.password)}
                            helperText={errors.password}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Нэвтрэх
                        </Button>
                        <Grid container>
                            <Grid item xs>
                                <NavLink
                                    to={ROUTES_LIST.restorePassword}
                                >
                                    <Typography color="secondary.main" sx={{float: 'right'}}>Нууц үгээ мартсан?</Typography>
                                </NavLink>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
        </ThemeProvider>
    );
}
